<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/frame2.mp4" type="video/mp4" />
    </video>
  </div>
  <p>Ensure that all of the frames you want to import have been tagged.</p>
  <p>Use right-mouse to pan, and scroll to zoom.</p>
</div>
